// Test IDs for the Servicios (Service catalog) feature.

export const SERVICES = {
        addButton: 'services-add-button',
        grid: 'services-grid',
        cardPrefix: 'services-card-', // services-card-<serviceId>
        editButtonPrefix: 'services-edit-button-',
        deleteButtonPrefix: 'services-delete-button-',
        emptyState: 'services-empty-state',

        modalNameInput: 'services-modal-name-input',
        modalDescriptionInput: 'services-modal-description-input',
        modalShortDescriptionInput: 'services-modal-short-description-input',
        modalCategorySelect: 'services-modal-category-select',
        modalDurationInput: 'services-modal-duration-input',
        modalPriceInput: 'services-modal-price-input',
        modalPriceTypeSelect: 'services-modal-price-type-select',
        modalPriceNoteInput: 'services-modal-price-note-input',
        modalPhotoUpload: 'services-modal-photo-upload',
        modalProfessionalCheckboxPrefix: 'services-modal-professional-checkbox-',
        modalSaveButton: 'services-modal-save-button',
        modalCancelButton: 'services-modal-cancel-button',

        categoryFilterSelect: 'services-category-filter-select',
        importButton: 'services-import-button',

        importModal: 'services-import-modal',
        importPasteTextarea: 'services-import-paste-textarea',
        importFileInput: 'services-import-file-input',
        importPreviewButton: 'services-import-preview-button',
        importPreviewTable: 'services-import-preview-table',
        importPreviewRowPrefix: 'services-import-preview-row-', // + index
        importDuplicateActionSelectPrefix: 'services-import-duplicate-action-select-', // + index
        importConfirmButton: 'services-import-confirm-button',
        importCancelButton: 'services-import-cancel-button',
        importBackButton: 'services-import-back-button',
        importResultSummary: 'services-import-result-summary',
        importError: 'services-import-error',

        deleteConfirmButton: 'services-delete-confirm-button',
        deleteCancelButton: 'services-delete-cancel-button',

        bulkUploadButton: 'services-bulk-upload-button',
        bulkModal: 'services-bulk-modal',
        bulkDropzone: 'services-bulk-dropzone',
        bulkFileInput: 'services-bulk-file-input',
        bulkTable: 'services-bulk-table',
        bulkRowPrefix: 'services-bulk-row-', // + index
        bulkServiceSelectPrefix: 'services-bulk-service-select-', // + index
        bulkRemoveButtonPrefix: 'services-bulk-remove-button-', // + index
        bulkReplaceBadgePrefix: 'services-bulk-replace-badge-', // + index
        bulkNoMatchBadgePrefix: 'services-bulk-no-match-badge-', // + index
        bulkDuplicateWarning: 'services-bulk-duplicate-warning',
        bulkConfirmButton: 'services-bulk-confirm-button',
        bulkCancelButton: 'services-bulk-cancel-button',
        bulkBackButton: 'services-bulk-back-button',
        bulkResultSummary: 'services-bulk-result-summary',
        bulkProgress: 'services-bulk-progress',

        modalKindSelect: 'services-modal-kind-select',
        modalPromoToggle: 'services-modal-promo-toggle',
        modalPromoPriceInput: 'services-modal-promo-price-input',
        modalPromoLabelInput: 'services-modal-promo-label-input',
        modalPromoStartInput: 'services-modal-promo-start-input',
        modalPromoEndInput: 'services-modal-promo-end-input',
        modalPaymentModeSelect: 'services-modal-payment-mode-select',
        modalPaymentDepositTypeSelect: 'services-modal-payment-deposit-type-select',
        modalPaymentDepositValueInput: 'services-modal-payment-deposit-value-input',
        cardPromoRegular: 'services-card-promo-regular-', // + serviceId
        cardKindBadgePrefix: 'services-card-kind-badge-', // + serviceId
        reviewIncludedDaysInput: 'services-modal-review-included-days-input',
        modalSuggestedZoneCheckboxPrefix: 'services-modal-suggested-zone-checkbox-',
        modalShowDurationToggle: 'services-modal-show-duration-toggle',
};
